import { render, staticRenderFns } from "./ImportRedirect.vue?vue&type=template&id=ffc8d354"
import script from "./ImportRedirect.vue?vue&type=script&lang=js"
export * from "./ImportRedirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports